import React from 'react';
import { FormattedMessage, useIntl } from 'react-intl-next';
import { messages } from '../../../../messages';
import { EmptyState } from '../../components/EmptyState';
import { ErrorSVG } from './error-svg';
var RelatedLinksErroredView = function RelatedLinksErroredView() {
  var intl = useIntl();
  return /*#__PURE__*/React.createElement(EmptyState, {
    renderImage: function renderImage() {
      return /*#__PURE__*/React.createElement(ErrorSVG, null);
    },
    header: intl.formatMessage(messages.related_links_modal_error_header),
    description: /*#__PURE__*/React.createElement(FormattedMessage, messages.related_links_modal_error_message)
  });
};
export default RelatedLinksErroredView;